/* BF homepage redesign: play a Shopify-hosted video only after a tap on Play.
   The <video> markup waits in a <template> next to the button, so no video bytes load with the page. */
(function () {
  if (window.__bfHomeVideos) return;
  window.__bfHomeVideos = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bfh-play]') : null;
    if (!btn) return;
    e.preventDefault();
    var box = btn.parentNode;
    var tpl = box && box.querySelector('template[data-bfh-player]');
    if (!tpl || box.getAttribute('data-bfh-playing') === '1') return;

    var frag = tpl.content.cloneNode(true);
    var video = frag.querySelector('video');
    if (!video) {
      /* YouTube: the iframe autoplays after the tap (28.10) */
      if (!frag.querySelector('iframe')) return;
      box.setAttribute('data-bfh-playing', '1');
      box.appendChild(frag);
      btn.hidden = true;
      return;
    }
    video.setAttribute('playsinline', '');
    video.controls = true;
    box.setAttribute('data-bfh-playing', '1');
    box.appendChild(frag);
    btn.hidden = true;

    /* the tap is a user gesture, so sound is allowed; if the browser still refuses, start muted */
    var started = video.play();
    if (started && started.catch) {
      started.catch(function () {
        video.muted = true;
        video.play().catch(function () {});
      });
    }
  });

  /* one video at a time: starting a video pauses the others on the page */
  document.addEventListener('play', function (e) {
    var vids = document.querySelectorAll('.bf-home video');
    for (var i = 0; i < vids.length; i++) {
      if (vids[i] !== e.target && !vids[i].paused) vids[i].pause();
    }
  }, true);
})();
